import React from 'react';
import {Link, withRouter} from 'react-router';
import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

import ProfileCoach from '../pages/profile-coach';
import Splash_Signin from "../../homecomponents/commons/splash_signin";

class ProfileCoachPublicPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            menuShow: false
        };
    }

    componentDidMount() {}

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        this.props.router.push(link);
    }

    render() {
        let params = {profileId: this.props.params.profileId}
        return (
            <div>
                {isMobile ?
                    <div className="advertise_boxx" id="a_project_mobile">
                        <div className={"block-001 row mr0"}>
                            <Link to="/"><img className={"img_logo"} style={{width: "90px"}} src="/static/img/appimg/top_login_h_logo.png"/></Link>
                            <div className={"mobile-dropdown"}>
                                <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                    <title>Menu</title>
                                    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                                </svg>
                                <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                    <li onClick={() => this.mouseLinkClick("/employers/signup")}><span>Join</span></li>
                                    <li onClick={() => this.mouseLinkClick("/projects/signin")}><span>Sign in</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    :
                    <div id="company">
                        <header>
                            <div className="header">
                                <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                                <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                            </div>
                        </header>
                        <div className="splash_wrapper"></div>
                    </div>
                }
                <ProfileCoach params={params} isPublic={true}/>
            </div>
        )
    }
}

export default (withRouter(ProfileCoachPublicPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/pages/profilepulic-coach.js
 **/